/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import createChainedFunction from 'utils/createChainedFunction';
import focusNode from 'utils/focusNode';
import KeyConstants from 'constants/KeyConstants';
import pickTextareaElementProps from 'utils/pickTextareaElementProps';

const BORDER_HEIGHT = 2;

import './styles/Textarea.scss';

class Textarea extends React.Component {
  static propTypes = {
    rows: React.PropTypes.number,
    autogrow: React.PropTypes.bool,
    onHeightChange: React.PropTypes.func,
    onUpdate: React.PropTypes.func,
    placeholder: React.PropTypes.string,
    autofocus: React.PropTypes.bool,
    autoselect: React.PropTypes.bool,
    value: React.PropTypes.string,
    onReturnKeyPress: React.PropTypes.func,
  };

  static defaultProps = {
    autogrow: false,
    autofocus: false,
    autoselect: false,
    rows: 3,
  };

  componentDidMount() {
    if (this.props.autogrow) {
      this.recalculateSize();
      window.addEventListener('resize', this.recalculateSize, false);
    }

    if (this.props.autofocus) {
      // Prevents the cursor from being placed at the start of the text
      const value = this.getInputNode().value;
      this.getInputNode().value = '';
      focusNode(this.getInputNode());
      this.getInputNode().value = value;
    }

    if (this.props.autoselect) {
      this.select();
    }
  }

  componentDidUpdate() {
    if (this.props.autogrow) {
      this.recalculateSize();
    }
    if (this.props.onUpdate) {
      this.props.onUpdate();
    }
  }

  componentWillUnmount() {
    if (this.props.autogrow) {
      window.removeEventListener('resize', this.recalculateSize, false);
    }
  }

  getInputNode = () => {
    return ReactDOM.findDOMNode(this.refs.textarea);
  };

  select = () => {
    this.getInputNode().select();
  };

  focus = () => {
    this.getInputNode().focus();
  };

  clear = () => {
    this.getInputNode().value = '';
  };

  handleChange = () => {
    if (this.props.autogrow) {
      this.recalculateSize();
    }
  };

  handleKeyDown = (event: SyntheticKeyboardEvent) => {
    if (this.props.onReturnKeyPress && event.keyCode === KeyConstants.ENTER) {
      if (this.props.onReturnKeyPress(event)) {
        event.stopPropagation();
      }
    }
  };

  height = null;

  recalculateSize = () => {
    const node = ReactDOM.findDOMNode(this);
    node.style.height = 'auto';

    const height = node.scrollHeight + BORDER_HEIGHT;
    node.style.height = height + 'px';
    if (this.height !== height) {
      this.height = height;
      if (this.props.onHeightChange) {
        this.props.onHeightChange();
      }
    }
  };

  render() {
    const { children, placeholder, onChange, className, value, ...others } = this.props;
    let initialValue = '';
    if (value) {
      initialValue = value;
    } else if (children) {
      initialValue = children;
    }

    const props = pickTextareaElementProps(others);

    return (
      <textarea
        {...props}
        value={initialValue}
        ref="textarea"
        onKeyDown={this.handleKeyDown}
        placeholder={placeholder}
        className={cx('Textarea', className)}
        onChange={createChainedFunction(onChange, this.handleChange)}
      />
    );
  }
}

export default Textarea;



// WEBPACK FOOTER //
// ./src/components/Textarea.jsx